/**
 * What the screens do with photos the server refused: say which and why, and
 * keep exactly those in the form for another try. Pure, tested.
 */
import type { ImageUploadFailure } from '../data/types';
import { tx } from '../i18n/extra';

/** "1 von 3 Fotos nicht hochgeladen: Foto 2: Das Foto enthält noch Metadaten." */
export function failureSummary(failures: readonly ImageUploadFailure[], total: number): string {
  const details = failures.map((f) => tx.upload.photoFailed(f.index + 1, f.message)).join(' · ');
  return `${tx.upload.someFailed(failures.length, total)}: ${details}`;
}

/** The refused photos, in their original order, each with its reason. */
export function keepFailed<P>(photos: readonly P[], failures: readonly ImageUploadFailure[]): { photos: P[]; errors: string[] } {
  const sorted = [...failures].sort((a, b) => a.index - b.index);
  const kept: P[] = [];
  const errors: string[] = [];
  for (const f of sorted) {
    const p = photos[f.index];
    if (p === undefined) continue;
    kept.push(p);
    errors.push(f.message);
  }
  return { photos: kept, errors };
}
